<template>
  <div class="mb-4">
    <b-input-group>
      <b-form-input :value="searchTerm" placeholder="Szukaj w całej bazie tłumaczeń..." @input="handleSearch" />
      <template #append v-if="searchTerm">
        <b-button variant="outline-secondary" @click="clearSearch">
          <feather-icon icon="XIcon" size="16" />
        </b-button>
      </template>
    </b-input-group>

    <!-- Search Results -->
    <div v-if="searchResults.length > 0" class="global-search-results mt-3">
      <h6 class="mb-2">Wyniki wyszukiwania ({{ searchResults.length }})</h6>
      <div class="search-results-container">
        <div
          v-for="result in displayedResults"
          :key="result.key"
          class="search-result-item p-2 border rounded mb-2"
          @click="navigateToResult(result)">
          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1">
              <small class="text-muted">{{ result.key }}</small>
              <div class="font-weight-medium">{{ result.value }}</div>
            </div>
            <b-badge :variant="getCategoryColor(result.category)" class="ml-2">
              {{ getCategoryName(result.category) }}
            </b-badge>
          </div>
        </div>
      </div>

      <div v-if="searchResults.length > maxDisplayedResults" class="text-center mt-2">
        <b-button variant="outline-primary" size="sm" @click="toggleShowAll">
          {{ showAllResults ? 'Pokaż mniej' : `Pokaż wszystkie (${searchResults.length})` }}
        </b-button>
      </div>
    </div>

    <!-- No Results -->
    <div v-else-if="searchTerm && searchResults.length === 0" class="text-center py-3">
      <feather-icon icon="SearchIcon" size="32" class="text-muted mb-2" />
      <p class="text-muted mb-0">Brak wyników dla "{{ searchTerm }}"</p>
    </div>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

export default {
  name: 'GlobalSearch',
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
    searchResults: {
      type: Array,
      default: () => [],
    },
    translationCategories: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['search', 'clear-search', 'navigate-to-result'],
  setup(props, { emit }) {
    const showAllResults = ref(false);
    const maxDisplayedResults = 5;

    const displayedResults = computed(() => {
      if (showAllResults.value) {
        return props.searchResults;
      }
      return props.searchResults.slice(0, maxDisplayedResults);
    });

    const handleSearch = (searchTerm) => {
      emit('search', searchTerm);
    };

    const clearSearch = () => {
      showAllResults.value = false;
      emit('clear-search');
    };

    const navigateToResult = (result) => {
      emit('navigate-to-result', result);
    };

    const toggleShowAll = () => {
      showAllResults.value = !showAllResults.value;
    };

    const getCategoryName = (categoryId) => {
      return props.translationCategories[categoryId]?.name || categoryId;
    };

    const getCategoryColor = (categoryId) => {
      return props.translationCategories[categoryId]?.color || 'secondary';
    };

    return {
      showAllResults,
      maxDisplayedResults,
      displayedResults,
      handleSearch,
      clearSearch,
      navigateToResult,
      toggleShowAll,
      getCategoryName,
      getCategoryColor,
    };
  },
};
</script>

<style scoped>
.search-result-item {
  cursor: pointer;
  transition: all 0.3s ease;
}

.search-result-item:hover {
  background-color: #f8f9fa;
  border-color: #007bff !important;
}

.global-search-results {
  max-height: 400px;
  overflow-y: auto;
}

.search-results-container {
  max-height: 300px;
  overflow-y: auto;
}
</style>
